import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import colorConfigs from "../../configs/colorConfigs";
import { RouteType } from "../../routes/config";
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { useSelector } from "react-redux";
import SidebarItem from "./SidabarItem";
import { RootState } from "../../Redux/store";
import { useTranslation } from "react-i18next";

type Props = {
  item: RouteType;
  openDrawer: boolean;
  setOpenDrawer: (open: boolean) => void;
};

const SidebarItemCollapse = ({ item, openDrawer, setOpenDrawer }: Props) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("appRoutes");
  const { appState } = useSelector((state: RootState) => state.appState);
  const userRole = useSelector((state: any) => state.general.userRol);

  useEffect(() => {
    if (appState.includes(item.state)) {
      setOpen(true);
    }
  }, [appState, item]);

  useEffect(() => {
    if (!openDrawer) {
      setOpen(false);
    }
  }, [openDrawer]);

  useEffect(() => {
}, [item.sidebarProps.displayText]);

  const handleClickButton = () => {
    if (!openDrawer) {
      setOpenDrawer(true);
    }
    setOpen(!open);
  };

  if (!item.sidebarProps || (item.allowedRoles && !item.allowedRoles.includes(userRole))) return null;

  return (
    <>
      <ListItemButton
        onClick={handleClickButton}
        sx={{
          "&: hover": {
            backgroundColor: colorConfigs.sidebar.hoverBg
          },
          paddingY: "12px"
        }}
      >
        <ListItemIcon sx={{
          color: colorConfigs.sidebar.color,
          justifyContent: 'center'
        }}>
          {item.sidebarProps.icon && item.sidebarProps.icon}
        </ListItemIcon>
        <ListItemText
          disableTypography
          sx={{ color: colorConfigs.sidebar.color }}
          primary={
            <Typography sx={{ opacity: openDrawer ? 1 : 0 }}>
              {t(item.sidebarProps.displayText)}
            </Typography>
          }
        />
        {open ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon sx={{ opacity: openDrawer ? 1 : 0 }} />}
      </ListItemButton>
      <Collapse in={open} timeout="auto">
        <List>
          {item.child?.map((route, index) =>
            route.sidebarProps && (!route.allowedRoles || route.allowedRoles.includes(userRole)) ? (
              route.child ? (
                <SidebarItemCollapse item={route} openDrawer={openDrawer} key={index} setOpenDrawer={setOpenDrawer} />
              ) : (
                <SidebarItem item={route} key={index} open={openDrawer} setOpen={setOpenDrawer} />
              )
            ) : null
          )}
        </List>
      </Collapse>
    </>
  );
};

export default SidebarItemCollapse;
